import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { siteInfo } from '@/mocks/site';

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-20 bg-primary-950 text-background-200">
      <div className="mx-auto w-full px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2 lg:pr-10">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-primary-950">
                <i className="ri-arrow-go-back-line text-lg" aria-hidden="true" />
              </span>
              <strong className="font-heading text-xl font-bold text-background-50">
                {siteInfo.name}
              </strong>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-background-300">
              {siteInfo.intro}
            </p>
            <p className="mt-4 max-w-md text-xs leading-relaxed text-background-400">
              {siteInfo.notice}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">站点导航</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/" className="text-background-300 transition-colors hover:text-accent-300">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/archive" className="text-background-300 transition-colors hover:text-accent-300">
                  反转档案
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-background-300 transition-colors hover:text-accent-300">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-background-300 transition-colors hover:text-accent-300">
                  常见问题
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50">案例分类</h4>
            <ul className="mt-4 space-y-2.5 text-sm">
              {categories.map((item) => (
                <li key={item.key}>
                  <Link
                    to={`/archive?category=${item.key}`}
                    className="text-background-300 transition-colors hover:text-accent-300"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-primary-800 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {siteInfo.name} · {siteInfo.slogan}</p>
          <p className="flex flex-wrap items-center gap-4">
            <span>联系邮箱：{siteInfo.email}</span>
            <span className="flex items-center gap-1">
              <i className="ri-information-line" aria-hidden="true" />
              内容仅供参考，以官方通报为准
            </span>
          </p>
        </div>
      </div>
    </footer>
  );
}